import moment from 'moment';

export const FETCH_EXTRACT_TOTALIZERS = 'FETCH_EXTRACT_TOTALIZERS';
export const FETCH_EXTRACT_TOTALIZERS_SUCCESS = `${FETCH_EXTRACT_TOTALIZERS}_SUCCESS`;
export const FETCH_EXTRACT_TOTALIZERS_FAIL = `${FETCH_EXTRACT_TOTALIZERS}_FAIL`;

/* eslint-disable */
const TotalizersReducer = (
  state = {
    isLoading: false,
    isLoaded: false,
    createdAt: '',
    error: null
  },
  action = {},
) => {
  switch (action.type) {
    case FETCH_EXTRACT_TOTALIZERS:
      return { ...state, isLoading: true };
    case FETCH_EXTRACT_TOTALIZERS_SUCCESS:
      const { data } = action.payload;
      const createdAt = moment().utc(data.insertDate).format('DD/MM/YYYY');
      return {
        ...state,
        createdAt ,
        isLoading: false,
        isLoaded: true,
        onHold: data.lockedBalance,
        expired: data.expiredBalance,
        redeemed: data.redeemBalance,
        credited: data.creditBalance,
      };
    case FETCH_EXTRACT_TOTALIZERS_FAIL:
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        error: action.error,
      };
    default:
      return state;
  }
};

export default TotalizersReducer;
